import { render, staticRenderFns } from "./LogSettings.vue?vue&type=template&id=c1651b8a&"
import script from "./LogSettings.vue?vue&type=script&lang=js&"
export * from "./LogSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports